import { disableEditFlow } from 'actionCreators/navigation';
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';

const FormSubmitButton = ({
  formName,
  disabled,
  dispatch,
  label = 'Continue',
  isLoading = false,
  makeLoanEditSubmit,
  isMakeLoanEdit,
  selectedLoanAmount,
  selectedTermValue
}) => (
  <NavigationButton.Primary
    disabled={disabled}
    labelText={label}
    isLoading={isLoading}
    onClick={() => {
      if (isMakeLoanEdit) {
        makeLoanEditSubmit();
        selectedLoanAmount && selectedTermValue && dispatch(disableEditFlow());
      } else {
        dispatch(submit(formName));
      }
    }}
  />
);

const ConnectedFormSubmitButton = connect()(FormSubmitButton);

export { ConnectedFormSubmitButton as FormSubmitButton };
